import { Theme } from "@mui/material";
import { height } from "@mui/system";

const useStyles = (theme: Theme) => ({
  boxContainer: (direction: "row" | "column", isPaginated: Boolean) => ({
    display: "flex",
    flexDirection: direction,
    overflow: "hidden",
    alignItems: "center",
    gap: 1,
    ...(isPaginated
      ? {
          backgroundColor: "background.card",
          borderRadius: 2,
          width: "100%",
          height: "100%",
          padding: 2,
        }
      : {
          height: "100%",
          width: "100%",
          paddingBottom: 2.3,
        }),
  }),
  pagination: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  boxStatus: (isPaginated: Boolean) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: { xs: 1.2, lg: 0.8 },
    paddingX: isPaginated ? 2 : 0,
    width: "100%",
    height: "100%",
  }),
  boxLinearProgress: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    paddingTop: 0.5,
  },
  linearProgress: {
    width: "100%",
    height: 8,
    borderRadius: 2,
    "& .MuiLinearProgress-bar2Buffer": {
      backgroundColor: "background.textField",
    },
  },
});

export default useStyles;
